module.exports = __webpack_public_path__ + "img/Logo-AFPI-new.6c0736ef.png";